// extracted by mini-css-extract-plugin
module.exports = {"bgImage":"landingBg_bgImage__Es6jd","float1":"landingBg_float1__90SMC","float2":"landingBg_float2__l9Xyi","float3":"landingBg_float3__57Ha8","bgMask":"landingBg_bgMask__8UOKb"};